import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import RegistrarCliente from "components/RegistrarCliente";
import DetallesCliente from "components/DetallesCliente";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import { useMaterialUIController } from "context";

function Clientes_y_CRM() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const [clientes, setClientes] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openRegistrar, setOpenRegistrar] = useState(false);
  const [openDetalles, setOpenDetalles] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleOpenMenu = (event, cliente) => {
    setMenuAnchor(event.currentTarget);
    setSelectedCliente(cliente);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleOpenDetalles = () => {
    setOpenDetalles(true);
    handleCloseMenu();
  };

  const handleCloseDetalles = () => {
    setOpenDetalles(false);
    setSelectedCliente(null);
  };

  const handleOpen = () => setOpenRegistrar(true);
  const handleClose = () => setOpenRegistrar(false);

  const fetchClientes = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_ENDPOINTS.CLIENTES);
      const clientesData = response.data;

      // Transform data for DataTable
      const rows = clientesData.map((cliente) => ({
        id: cliente.id,
        empresa: cliente.empresa?.nombre || "N/A",
        nombre: cliente.nombre,
        documento: (
          <MDBox>
            <MDTypography variant="caption" fontWeight="medium">
              {cliente.tipo_documento}: {cliente.rif}
            </MDTypography>
          </MDBox>
        ),
        email: cliente.email || "N/A",
        telefono: cliente.telefono || "N/A",
        tipo: (
          <MDBadge
            badgeContent={cliente.tipo || "minorista"}
            color={
              cliente.tipo === "corporativo"
                ? "success"
                : cliente.tipo === "mayorista"
                  ? "info"
                  : "secondary"
            }
            variant="gradient"
            size="sm"
          />
        ),
        estatus: (
          <MDBadge
            badgeContent={cliente.estatus === "activo" ? "Activo" : "Inactivo"}
            color={cliente.estatus === "activo" ? "success" : "dark"}
            variant="gradient"
            size="sm"
          />
        ),
        accion: (
          <IconButton onClick={(event) => handleOpenMenu(event, cliente)}>
            <Icon>more_vert</Icon>
          </IconButton>
        ),
      }));

      const columns = [
        { Header: "Empresa", accessor: "empresa", width: "15%" },
        { Header: "Nombre", accessor: "nombre", width: "20%" },
        { Header: "Documento", accessor: "documento", width: "15%" },
        { Header: "Email", accessor: "email", width: "15%" },
        { Header: "Teléfono", accessor: "telefono", width: "10%" },
        { Header: "Tipo", accessor: "tipo", width: "10%" },
        { Header: "Estado", accessor: "estatus", width: "10%" },
        { Header: "Acción", accessor: "accion", width: "5%" },
      ];

      setClientes({ columns, rows });
      setLoading(false);
    } catch (err) {
      console.error("Error al cargar clientes:", err);
      setError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClientes();
  }, []);

  const handleSearch = (value) => {
    setSearchTerm(value);
    // Implementar búsqueda en el backend si es necesario
  };

  const handleSuccess = () => {
    fetchClientes(); // Recargar la lista
  };

  const renderMenu = () => (
    <Menu
      anchorEl={menuAnchor}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(menuAnchor)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <MenuItem onClick={handleOpenDetalles}>
        <MDTypography variant="body2" color="dark">
          Ver Detalles
        </MDTypography>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleCloseMenu}>
        <MDTypography variant="body2" color="dark">
          Editar
        </MDTypography>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleCloseMenu}>
        <MDTypography variant="body2" color="dark">
          Eliminar
        </MDTypography>
      </MenuItem>
    </Menu>
  );

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Clientes y CRM
                  </MDTypography>
                </MDBox>
                <MDBox pt={3} px={3}>
                  <MDTypography variant="body2" color="text" fontWeight="medium">
                    Cargando lista de clientes...
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Clientes y CRM
                  </MDTypography>
                </MDBox>
                <MDBox pt={3} px={3}>
                  <MDTypography variant="body2" color="error" fontWeight="medium">
                    Error al cargar la lista de clientes: {error.message}
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Clientes y CRM
                </MDTypography>
              </MDBox>
              <MDBox padding={3}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <MDButton variant="gradient" color={sidenavColor} onClick={handleOpen}>
                    <Icon>add</Icon>&nbsp; Registrar Cliente
                  </MDButton>
                  <MDBox component="form" display="flex" justifyContent="flex-end">
                    <input
                      type="text"
                      placeholder="Buscar cliente..."
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{
                        padding: "8px 12px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        fontSize: "14px",
                        minWidth: "250px",
                      }}
                    />
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={clientes}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                {renderMenu()}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Modal de Registro */}
      <RegistrarCliente open={openRegistrar} onClose={handleClose} onSuccess={handleSuccess} />

      {/* Modal de Detalles */}
      <DetallesCliente
        open={openDetalles}
        onClose={handleCloseDetalles}
        cliente={selectedCliente}
      />
    </DashboardLayout>
  );
}

export default Clientes_y_CRM;

